import React, { useCallback, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { ArrowsExpandIcon } from "@heroicons/react/outline";
import { socialImageUrl } from "../../utils/socialImages";

// Taller than 4:5 gets cropped from the top in the feed; the lightbox shows it all.
const TALL_RATIO = 1.25;

const ImageLightbox = ({ url, onClose }) => {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    const previousOverflow = document.body.style.overflow;
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = previousOverflow;
    };
  }, [onClose]);

  return createPortal(
    <div
      className="image-lightbox"
      role="dialog"
      aria-modal="true"
      aria-label="Φωτογραφία"
      onClick={onClose}
    >
      <img src={url} alt="" onClick={(e) => e.stopPropagation()} />
      <button
        type="button"
        className="image-lightbox-close"
        onClick={onClose}
        aria-label="Κλείσιμο"
      >
        ×
      </button>
    </div>,
    document.body
  );
};

const PostImage = ({ name }) => {
  const [tall, setTall] = useState(false);
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);

  if (!name) return null;
  const url = socialImageUrl(name);

  return (
    <>
      <button
        type="button"
        className={`post-image${tall ? " post-image--tall" : ""}`}
        onClick={() => setOpen(true)}
        aria-label="Προβολή φωτογραφίας"
      >
        <img
          src={url}
          alt="Φωτογραφία ανάρτησης"
          loading="lazy"
          onLoad={(e) => {
            const img = e.currentTarget;
            setTall(img.naturalHeight > img.naturalWidth * TALL_RATIO);
          }}
        />
        {tall && (
          <span className="post-image-expand" aria-hidden="true">
            <ArrowsExpandIcon />
          </span>
        )}
      </button>
      {open && <ImageLightbox url={url} onClose={close} />}
    </>
  );
};

export default PostImage;
